import { Point } from '../types';
import { Vertex3 } from '../vertex-3.class';

export const addCfn = <T extends Point>(point: T, distance: T): T => {
	// Add the x, y, and z properties of distance to the corresponding properties of point
	point.x += distance.x;
	point.y += distance.y;
	if (point instanceof Vertex3) point.z += (distance as Vertex3).z;

	return point;
}
